var map = {
	"./CU. BRI.svg": 9335,
	"./HEART.svg": 6164,
	"./KITE.svg": 3977,
	"./LOZENGE.svg": 4598,
	"./MARQ.svg": 2233,
	"./OLD EUROPEAN.svg": 710,
	"./ROUND ROSE.svg": 2069,
	"./ROUND.svg": 7376,
	"./TRIANGLE.svg": 940,
	"./hexa-01.svg": 8936,
	"./oval-01.svg": 7032,
	"./pear.svg": 1456,
	"Assets/Image/shapeFrames/CU. BRI.svg": 9335,
	"Assets/Image/shapeFrames/HEART.svg": 6164,
	"Assets/Image/shapeFrames/KITE.svg": 3977,
	"Assets/Image/shapeFrames/LOZENGE.svg": 4598,
	"Assets/Image/shapeFrames/MARQ.svg": 2233,
	"Assets/Image/shapeFrames/OLD EUROPEAN.svg": 710,
	"Assets/Image/shapeFrames/ROUND ROSE.svg": 2069,
	"Assets/Image/shapeFrames/ROUND.svg": 7376,
	"Assets/Image/shapeFrames/TRIANGLE.svg": 940,
	"Assets/Image/shapeFrames/hexa-01.svg": 8936,
	"Assets/Image/shapeFrames/oval-01.svg": 7032,
	"Assets/Image/shapeFrames/pear.svg": 1456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3344;